"use strict";

window.okeReviewsWidgetOnInit = function () {
  setupHeader();
};

function setupHeader() {
  var writeReviewButton = document.querySelector(".js-okeReviews-writeReview");
  var writeReviewButtonClone = writeReviewButton.cloneNode(true);
  writeReviewButtonClone.classList.remove("okeReviews-reviewsWidget-header-controls-writeReview");
  moveDiv(".okeReviews-reviewsAggregate-summary", writeReviewButton);
  moveDiv(".okeReviews-reviews-controls", writeReviewButtonClone, true);
}
/*
* moveDiv moves target selector to destination selector with append by default.
* selectors should be a string with same format that document.querySelector requires
*
* - target: element to move from, HTMLElement or selector
* - destination: element to move to, HTMLElement or selector
* - prepend: true to use prepend, false to append, default to append
* - parent: use parent.querySelector to select elements locally instead of globally
*
* */


function moveDiv(destination, target, prepend, parent) {
  parent = parent ? parent : document;
  var objectToMoveTo = destination instanceof HTMLElement ? destination : parent.querySelector(destination);
  var objectToMoveFrom = target instanceof HTMLElement ? target : parent.querySelector(target);

  if (objectToMoveFrom && objectToMoveTo) {
    prepend ? objectToMoveTo.prepend(objectToMoveFrom) : objectToMoveTo.append(objectToMoveFrom);
  }
}